import React from 'react';
import { TOKENS } from '../styles';

interface Props {
  text: string;
}

export default function EmptyBox({ text }: Props) {
  return (
    <div style={{
      background: TOKENS.card,
      border: '1px dashed ' + TOKENS.lineStrong,
      borderRadius: 12,
      padding: 26,
      textAlign: 'center',
      color: TOKENS.dark,
      fontWeight: 600,
    }}>
      {text}
    </div>
  );
}